import React from "react";
import moment from "moment/moment";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { HeartIcon } from "../../Images/svgs";

function ProjectCard({ project, index }) {
  const { images } = project;

  return (
    <>
      <div
        key={index}
        className="max-w-sm bg-white border border-gray-200 rounded-lg shadow"
      >
        <div className="p-1 space-y-4">
          <Carousel
            additionalTransfrom={0}
            sw
            arrows={false}
            autoPlaySpeed={3000}
            centerMode={false}
            className="mb-3"
            containerClass="container "
            dotListClass=""
            draggable={false}
            focusOnSelect={false}
            infinite={false}
            itemClass=""
            keyBoardControl
            minimumTouchDrag={80}
            pauseOnHover
            renderArrowsWhenDisabled={false}
            renderButtonGroupOutside={false}
            renderDotsOutside={false}
            responsive={{
              desktop: {
                breakpoint: {
                  max: 3000,
                  min: 1024,
                },
                items: 1,
              },
              mobile: {
                breakpoint: {
                  max: 464,
                  min: 0,
                },
                items: 1,
              },
              tablet: {
                breakpoint: {
                  max: 1024,
                  min: 464,
                },
                items: 1,
              },
            }}
            rewind={false}
            rewindWithAnimation={false}
            rtl={true}
            shouldResetAutoplay
            showDots
            sliderClass=""
            slidesToSlide={1}
            swipeable={false}
          >
            {Object.entries(images)
              .filter(([key, value]) => key === "image")
              .map(([key, imageUrl]) => (
                <div
                  key={key}
                  className="flex overflow-hidden relative flex-col justify-between self-stretch px-3 pt-3 pb-12 text-sm font-medium tracking-normal leading-3 text-center text-emerald-900 uppercase whitespace-nowrap rounded-md aspect-[1.26] "
                >
                  <img
                    src={imageUrl}
                    className="object-cover absolute inset-0 size-full"
                    alt={`Image for ${key}`}
                  />
                  <div className="flex relative gap-5 justify-between">
                    <div className="justify-center px-2.5 py-1 my-auto bg-emerald-100 rounded-xl border-emerald-900 border-solid border-[0.5px]">
                      بيوت فقراء
                    </div>
                    <HeartIcon fill={"red"} className="w-6 aspect-square" />
                  </div>
                </div>
              ))}
          </Carousel>
          <div className="px-2 space-y-4">
            <h5 className="text-2xl font-bold tracking-tight text-gray-900">
              {project.id}
            </h5>
            <span className="font-normal text-gray-700">
              آخر تبرع قبل {moment(project.updated_at).fromNow()}
            </span>
            <div className="relative w-237 h-2">
              <div className="absolute top-0 left-0 right-0 h-2 bg-gray-200 rounded-lg"></div>
              <div className="absolute top-0 right-0 h-2 w-24 bg-gradient-to-r from-blue-500 to-blue-900 rounded-lg"></div>
            </div>
            <div className="flex flex-row justify-between px-1">
              <span className="font-bold">{project.project_value} دولار</span>
              <span>$100,000 دولار</span>
            </div>
          </div>
          <div className="flex flex-col">
            <div className="flex flex-row items-center gap-1 mx-auto my-auto w-full sm:w-full md:w-full">
              <form className="flex flex-row border-2 rounded-lg">
                <input
                  className=" w-full outline-none text-lg indent-1 m-1"
                  type="text"
                  placeholder="القيمة"
                />
                <span className="flex items-center rounded rounded-l-none border-0 p-1 font-bold text-grey-100">
                  <button className="bg-blue-500 text-white text-sm py-2 px-4 rounded">
                    تبرع
                  </button>
                </span>
              </form>
              <span className="py-3 px-3 rounded-lg border-2">
                <svg
                  width="21"
                  height="20"
                  viewBox="0 0 21 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0_1363_108)">
                    <path
                      d="M5.38481 9.23083C5.38481 9.65567 5.7292 10.0001 6.15404 10.0001C6.57887 10.0001 6.92327 9.65567 6.92327 9.23083H5.38481ZM11.5386 8.4616C11.5386 8.88644 11.883 9.23083 12.3079 9.23083C12.7327 9.23083 13.0771 8.88644 13.0771 8.4616H11.5386ZM5.38481 13.077C4.95997 13.077 4.61558 13.4214 4.61558 13.8462C4.61558 14.2711 4.95997 14.6154 5.38481 14.6154V13.077ZM15.3848 11.5385C15.3848 11.1137 15.0404 10.7693 14.6156 10.7693C14.1907 10.7693 13.8463 11.1137 13.8463 11.5385H15.3848ZM13.8463 16.1539C13.8463 16.5787 14.1907 16.9231 14.6156 16.9231C15.0404 16.9231 15.3848 16.5787 15.3848 16.1539H13.8463ZM16.9233 14.6154C17.3481 14.6154 17.6925 14.2711 17.6925 13.8462C17.6925 13.4214 17.3481 13.077 16.9233 13.077V14.6154ZM12.3079 13.077C11.883 13.077 11.5386 13.4214 11.5386 13.8462C11.5386 14.2711 11.883 14.6154 12.3079 14.6154V13.077ZM6.92327 9.23083V4.61544H5.38481V9.23083H6.92327ZM11.5386 4.61544V8.4616H13.0771V4.61544H11.5386ZM9.23095 2.30775C10.0236 2.30775 10.582 2.56656 10.943 2.94053C11.3083 3.31878 11.5386 3.88439 11.5386 4.61544H13.0771C13.0771 3.55772 12.7383 2.58486 12.0497 1.87184C11.3571 1.15455 10.377 0.769287 9.23095 0.769287V2.30775ZM9.23095 0.769287C8.08495 0.769287 7.10485 1.15455 6.41218 1.87184C5.72362 2.58486 5.38481 3.55772 5.38481 4.61544H6.92327C6.92327 3.88439 7.1536 3.31878 7.51886 2.94053C7.88003 2.56656 8.43834 2.30775 9.23095 2.30775V0.769287ZM5.38481 14.6154H9.23095V13.077H5.38481V14.6154ZM4.51643 6.1539H13.9455V4.61544H4.51643V6.1539ZM3.1848 15.3335L3.7489 6.87196L2.21385 6.76963L1.64975 15.2311L3.1848 15.3335ZM14.713 6.87196L14.8224 8.51275L16.3575 8.41044L16.2481 6.76963L14.713 6.87196ZM10.0002 16.1539H3.95233V17.6924H10.0002V16.1539ZM1.64975 15.2311C1.56095 16.5631 2.61741 17.6924 3.95233 17.6924V16.1539C3.50735 16.1539 3.1552 15.7775 3.1848 15.3335L1.64975 15.2311ZM13.9455 6.1539C14.3505 6.1539 14.6861 6.46789 14.713 6.87196L16.2481 6.76963C16.1673 5.5574 15.1604 4.61544 13.9455 4.61544V6.1539ZM4.51643 4.61544C3.30152 4.61544 2.29466 5.5574 2.21385 6.76963L3.7489 6.87196C3.77584 6.46789 4.11146 6.1539 4.51643 6.1539V4.61544ZM19.231 13.8462C19.231 16.3952 17.1646 18.4616 14.6156 18.4616V20.0001C18.0143 20.0001 20.7694 17.2449 20.7694 13.8462H19.231ZM14.6156 18.4616C12.0666 18.4616 10.0002 16.3952 10.0002 13.8462H8.46172C8.46172 17.2449 11.2169 20.0001 14.6156 20.0001V18.4616ZM10.0002 13.8462C10.0002 11.2972 12.0666 9.23083 14.6156 9.23083V7.69236C11.2169 7.69236 8.46172 10.4475 8.46172 13.8462H10.0002ZM14.6156 9.23083C17.1646 9.23083 19.231 11.2972 19.231 13.8462H20.7694C20.7694 10.4475 18.0143 7.69236 14.6156 7.69236V9.23083ZM13.8463 11.5385V13.8462H15.3848V11.5385H13.8463ZM13.8463 13.8462V16.1539H15.3848V13.8462H13.8463ZM16.9233 13.077H14.6156V14.6154H16.9233V13.077ZM14.6156 13.077H12.3079V14.6154H14.6156V13.077Z"
                      fill="#272727"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_1363_108">
                      <rect width="20.7692" height="20" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ProjectCard;
